module.exports = "<input type=text autocomplete=off kt-typeahead=\"\" role=combobox kt-typeahead-open-dropdown=openDropdown typeahead-on-select=\"locationSelected($item, $model, $label)\" uib-typeahead=\"address.description for address in getLocation($viewValue)\" typeahead-wait-ms=500 ng-model=address />";


//////////////////
// WEBPACK FOOTER
// ./src/app/directives/google-places/google-places-typeahead.html
// module id = 522
// module chunks = 0